import React, { Component } from 'react';

// import MasterPage from '../../masterpages/authenticated';
import TenantWarning from './componentes/TenantWarning';
import Indicadores from './componentes/Indicadores';
import Services from './componentes/Services';
import Ebook from './componentes/Ebook';
import Blog from './componentes/Blog';

import LogoBhs from '../../../assets/images/logo-bhs-icone.svg';
import ImgAcessoRemoto from '../../../assets/icons/acesso_remoto.svg';
import MasterPage from 'EstruturaAntiga/masterpages/authenticated';

class Dashboard extends Component {
	componentDidMount() {
		const lastUrl = sessionStorage.getItem('lastUrl');
		if (lastUrl && lastUrl !== window.location.pathname) {
			sessionStorage.removeItem('lastUrl');
			this.props.history.push(lastUrl);
			return;
		}
	}

	render() {
		return (
			<MasterPage className="dashboard">
				<TenantWarning />

				<Indicadores />

				<div className="container-dashboard-principal">
					<div className="row">
						<div className="col-12 col-lg-4 col-xl-4 order-1 order-lg-0">
							<Services />
						</div>

						<div className="col-12 col-lg-8 col-xl-8 order-0 order-lg-1">
							<Ebook />
						</div>
					</div>
				</div>


				<div className="row">
					<div className="col-12 col-lg-6 col-xl-6">
						<a
							className="links-home"
							href="https://www.bhs.com.br/"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img src={LogoBhs} alt="BHS" />
							<h2>Sobre a BHS</h2>
						</a>
					</div>

					<div className="col-12 col-lg-6 col-xl-6">
						<a
							className="links-home"
							href="https://get.teamviewer.com/axter"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img src={ImgAcessoRemoto} alt="Acesso Remoto" />
							<h2>Acesso Remoto</h2>
						</a>
					</div>
				</div>

				<Blog />
			</MasterPage>
		);
	};
}

export default Dashboard;
